import React, { Component } from "react";
import { Col, Row, Tabs } from "antd";
import { connect } from "react-redux";
import {
    getAllAssets,
    getAllAssetType,
    getTaggedDeviceAssets,
    getAssetDeviceLastData
} from "../../appRedux/actions/Asset";

import FleetOverviewCard from "./FleetOverviewCard";
import StatusCard from "./StatusCard";
import {
    downloadUnserviceableAsset,
    fetchAllFiltersData,
    fetchFilter,
    getAllJobs,
    getAllOpenJobsByCurrentStatus,
    getAllSpares,
    getATACount,
    getEquipmentSubTypeByAssetTypes,
    getIdealAssetCount,
    getModelByAssetMakes,
    getOpenCountWithJobs,
    getSTACount,
    getUnserviceableAssetCount,
    getVerifiedAssetCount
} from "../../appRedux/actions";
import { geJobDownloadByCurrentStatus as jobCardDownload } from "../../appRedux/actions/JobCard";
import Auxiliary from "../../util/Auxiliary";
import CurrentStatus from "./CurrentStatus/index";
// import BubbleMap from "../../components/dashboard/CRM/BubbleMap";
import Chart from "./Chart";
import SearchBar from "./SearchBar";
import DashboardTabs from "../../components/DashboardTabs";
import PackedBubbleChart from "./PackedBubbleChart";
import { calculateAssetTrends } from "../../util/assetTrendCalculator";


export class Dashboard extends Component {
    state = {
        searchPayload: null,
        devicePositionalData: [],
        isLastDataProcessFinished: false
    };

    setSearchPayload = payload => {
        // console.log('payload', payload)
        if (
            payload &&
            (!payload.location ||
                payload.location === "" ||
                payload.location === "All" ||
                !payload.location.length ||
                payload.location[0] === "All" ||
                payload.location[0] === "")
        ) {
            payload.location = (
                (this.props.authUser && this.props.authUser.locations) ||
                []
            )
                .map(item => {
                    if (item.name.toUpperCase() !== "SOLD") return item._id;
                })
                .filter(itm => itm);
        }

        this.getDashboardFigures(this.props.authUser, payload);
        this.setState({ searchPayload: payload })
        // console.log(payload);
        // this.setSearchPayload({
        //   searchPayload: payload
        // })
        //
        // const {organisation} = this.props.authUser || {};
        // const {assetProModules} = organisation || {};
        //
        // if ((assetProModules || []).includes('Tagging'))
        //     this.props.getAllAssets(payload);
        // if ((assetProModules || []).includes('SimpleMaintenance'))
        //     this.props.getUnserviceableAssetCount(payload);
        // if ((assetProModules || []).includes('SimpleMaintenance'))
        //     this.props.getOpenCountWithJobs(payload);
        // if ((assetProModules || []).includes('SimpleMaintenance'))
        //     this.props.getAllOpenJobsByCurrentStatus(payload);
        // if ((assetProModules || []).includes('Leasing'))
        //     this.props.getIdealAssetCount(payload);
        // if ((assetProModules || []).includes('Movement'))
        //     this.props.getATACount("Open", payload);
        // if ((assetProModules || []).includes('Movement'))
        //     this.props.getSTACount("Open", payload);
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps && nextProps.authUser && JSON.stringify(nextProps.authUser) !== JSON.stringify(this.props.authUser)) {
            const payload = { location: [] };
            if (
                payload &&
                (!payload.location ||
                    payload.location === "" ||
                    payload.location === "All" ||
                    !payload.location.length ||
                    payload.location[0] === "All" ||
                    payload.location[0] === "")
            ) {
                payload.location = (
                    (nextProps.authUser && nextProps.authUser.locations) ||
                    []
                )
                    .map(item => {
                        if (item.name.toUpperCase() !== "SOLD") return item._id;
                    })
                    .filter(itm => itm);
            }
            // console.log('2 ', payload)
            this.getDashboardFigures(nextProps.authUser, payload);
        }
    }

    componentDidMount() {
        const payload = { location: [] };
        if (
            payload &&
            (!payload.location ||
                payload.location === "" ||
                payload.location === "All" ||
                !payload.location.length ||
                payload.location[0] === "All" ||
                payload.location[0] === "")
        ) {
            payload.location = (
                (this.props.authUser && this.props.authUser.locations) ||
                []
            )
                .map(item => {
                    if (item.name.toUpperCase() !== "SOLD") return item._id;
                })
                .filter(itm => itm);
        }
        if (this.props.authUser) {
            // console.log('3 ', payload)
            this.getDashboardFigures(this.props.authUser, payload);
        }
    }

    getDashboardFigures = (authUser, payload) => {

        // console.log(authUser, payload)

        const { organisation } = authUser || {};
        const { assetProModules } = organisation || {};

        if ((assetProModules || []).includes('Tagging')) {
            // includeInTransit: also return assets on an open ATA from/to these locations.
            // They have no location while in transit, so the location filter alone drops them.
            this.props.getAllAssets({ ...payload, includeInTransit: true });
        }
        if ((assetProModules || []).includes('SimpleMaintenance')) {
            this.props.getUnserviceableAssetCount(payload);
        }
        if ((assetProModules || []).includes('SimpleMaintenance')) {
            this.props.getOpenCountWithJobs(payload);
        }
        if ((assetProModules || []).includes('SimpleMaintenance')) {
            this.props.getAllOpenJobsByCurrentStatus(payload);
        }
        if ((assetProModules || []).includes('Leasing')) {
            this.props.getIdealAssetCount(payload);
        }
        if ((assetProModules || []).includes('Movement')) {
            this.props.getATACount('Open', payload);
        }
        if ((assetProModules || []).includes('InventoryManagement')) {
            this.props.getSTACount('Open', payload);
        }

        // this.props.getAllJobs('');

        // this.props.getAllSpares();

        // // this.props.getAllOpenJobs('Open');

        // // this.props.getVerifiedAssetCount();


        // if(!this.props.equipmentSubTypes)
        //   this.props.getEquipmentSubTypeByAssetTypes('All');
        // if(!this.props.assetTypes)
        //   this.props.getAllAssetType();
    }

    handleUnserviceableAssetDownload = () => {
        this.props.downloadUnserviceableAsset();
    };

    setDevicePositionalData = (data) => {
        this.setState({ devicePositionalData: data })
    }

    callLastDataProcessFinished = (val) => {
        this.setState({ isLastDataProcessFinished: !!val })
    }

    render() {
        const {
            authUser,
            assets,
            assetLoading,
            spares,
            spareLoading,
            jobs,
            openJobs,
            jobLoading,
            usAssetCountLoading,
            usAssetCount,
            usActiveCount,
            usAssetLeaseCount,
            usAssetCountData,
            idealAssetCountLoading,
            idealAssetCount,
            verifiedAssetCountLoading,
            verifiedAssetCount,
            ataCount,
            ataAssetCount,
            ataCountLoading,
            staCount,
            staSpareCount,
            staCountLoading,
            openComplaintCountLoading,
            openComplaintCount,
            openComplaintCountWithoutJobs,
            navStyle,
            width
        } = this.props;
        // console.log(this.props.assetGroups);

        const countableAssets = (assets || []).filter(ast => (ast && ast.assetModel && ast.assetModel.isCountable));
        const inTransitCount = (assets || []).filter(ast => ast && ast.status === 'INTRANSIT' && !ast.location).length;
        const { newThisMonth, disposedThisMonth } = calculateAssetTrends(assets || []);

        const isTagOrSensorAsset = (ast) => !!(ast && ast.assetModel && (
            ast.assetModel.isTagDevice || ast.assetModel.isFuelSensorDevice
            || ast.assetModel.isRfidTag || ast.assetModel.isBleTag
        ));
        const excludingTagSensorAssetCount = (assets || []).filter(ast => ast && !isTagOrSensorAsset(ast)).length;
        const getDistinctParentCount = (flagKey) => {
            const parentIds = new Set();
            (assets || []).forEach(ast => {
                const parent = ast && ast.assetModel && ast.assetModel[flagKey] && ast.parent;
                if (parent) {
                    parentIds.add((parent && parent._id ? parent._id : parent).toString());
                }
            });
            return parentIds.size;
        };
        const fuelSensorParentAssetCount = getDistinctParentCount('isFuelSensorDevice');
        const gpsParentAssetCount = getDistinctParentCount('isTagDevice');
        const bleTaggedParentAssetCount = getDistinctParentCount('isBleTag');

        const orgModules = authUser && authUser.organisation && authUser.organisation.assetProModules || [];

        // ⚠️  DEPRECATED: Favicon is now locked to AssetPro branding and cannot be overridden
        // The favicon is protected by the protection script in index.html
        // Custom organisation favicons are no longer supported
        // if (authUser && authUser.organisation && authUser.organisation.favicon) {
        //     const faviconID = document.getElementById("favicon");
        //     if (faviconID) faviconID.href = authUser.organisation.favicon;
        // }
        return (
            <Auxiliary>
                <SearchBar
                    authUser={this.props.authUser}
                    documentFilters={this.props.documentFilters}
                    getEquipmentSubTypeByAssetTypes={
                        this.props.getEquipmentSubTypeByAssetTypes
                    }
                    getModelByAssetMakes={this.props.getModelByAssetMakes}
                    fetchAllFiltersData={this.props.fetchAllFiltersData}
                    equipmentSubTypes={this.props.equipmentSubTypes}
                    assetModels={this.props.assetModels}
                    setSearchPayload={this.setSearchPayload}
                />
                {/*<div style={{*/}
                {/*width: '100%',*/}
                {/*height: '100%',*/}
                {/*}}>*/}
                {/*<Chart loading={this.props.assetLoading} data={this.props.assetGroups} size={600}*/}
                {/*width={this.props.width}/>*/}
                {/*</div>*/}
                <Row className="fo-summary">
                    <Col xl={14} lg={14} md={24} sm={24} xs={24}>
                        <FleetOverviewCard
                            loading={assetLoading}
                            totalAssets={(assets && assets.length) || 0}
                            countable={countableAssets.length}
                            unique={((assets && assets.length) || 0) - countableAssets.length}
                            newThisMonth={newThisMonth}
                            disposedThisMonth={disposedThisMonth}
                            inTransit={inTransitCount}
                            showCoverage={!!(orgModules && orgModules.includes('Telematics'))}
                            exclTagSensor={excludingTagSensorAssetCount}
                            fuelSensor={fuelSensorParentAssetCount}
                            gps={gpsParentAssetCount}
                            ble={bleTaggedParentAssetCount}
                        />
                    </Col>

                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                        <StatusCard
                            loading={usAssetCountLoading || openComplaintCountLoading}
                            items={[
                                {
                                    icon: '/icons/empty.png',
                                    label: 'Unserviceable Equipment',
                                    value: usAssetCount || 0,
                                    helper: `${usActiveCount} in operations`,
                                    helperType: 'gold',
                                    actionLabel: 'View',
                                    onAction: this.handleUnserviceableAssetDownload
                                },
                                {
                                    icon: '/icons/failure.png',
                                    label: 'Total Open Complaints',
                                    value: openComplaintCount || 0,
                                    helper: `${openComplaintCountWithoutJobs} without Job card`,
                                    helperType: 'gold'
                                }
                            ]}
                        />
                    </Col>
                </Row>

                <Row>
                    {/* <Col span={24}>
                        <div className="gx-card">
                            <div className="gx-card-body">

                                <PackedBubbleChart loading={this.props.assetLoading}
                                    data={this.props.assetGroups} width={1380} height={400} />

                            </div>
                        </div>
                    </Col> */}

                    <Col span={24}>
                        <DashboardTabs
                            filterPayload={this.state.searchPayload}
                            assets={assets}
                            orgModules={orgModules}
                            taggedDevices={this.props.taggedDevices}
                            getTaggedDeviceAssets={this.props.getTaggedDeviceAssets}
                            isLastDataProcessFinished={this.callLastDataProcessFinished}
                            setDevicePositionalData={this.setDevicePositionalData}
                            devicePositionalData={this.state.devicePositionalData}
                        />
                    </Col>
                </Row>

                <Row className="dash-charts">
                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <div className="gx-card">
                            <div className="gx-card-body">
                                <CurrentStatus
                                    height={360}
                                    statusBreakup={openJobs}
                                    total={0}
                                    loading={jobLoading}
                                    {...this.props}
                                />
                            </div>
                        </div>
                    </Col>

                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Chart
                            loading={this.props.assetLoading}
                            data={this.props.assetGroups}
                            width={1850}
                        />
                        {/* <div className="gx-card">
                            <div className="gx-card-body">
                                <PackedBubbleChart loading={this.props.assetLoading}
                                    data={this.props.assetGroups} height={450} />
                            </div>
                        </div> */}
                    </Col>
                </Row>

                <Row className="fo-summary">
                    <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                        <StatusCard
                            loading={ataCountLoading}
                            items={[{ icon: '/icons/camera.png', label: 'Total Assets in Transit', value: ataAssetCount || 0 }]}
                        />
                    </Col>

                    <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                        <StatusCard
                            loading={ataCountLoading}
                            items={[{ icon: '/icons/feedback.png', label: 'Total Open ATA', value: ataCount || 0 }]}
                        />
                    </Col>

                    <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                        <StatusCard
                            loading={staCountLoading}
                            items={[{ icon: '/icons/truck.png', label: 'Total Open STA', value: staCount || 0 }]}
                        />
                    </Col>

                    <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                        <StatusCard
                            loading={idealAssetCountLoading}
                            items={[{ icon: '/icons/time.png', label: 'Total Idle Equipments', value: idealAssetCount || 0 }]}
                        />
                    </Col>


                    {/*<div className="ant-col gx-col-full ant-col-xs-24 ant-col-sm-24 ant-col-md-12 ant-col-lg-12 ant-col-xl-12">*/}
                    {/*<DealsClosedCard/>*/}
                    {/*</div>*/}

                    {/*<div className="ant-col gx-col-full ant-col-xs-24 ant-col-sm-24 ant-col-md-12 ant-col-lg-12 ant-col-xl-12">*/}
                    {/*<CurrentPlan/>*/}
                    {/*</div>*/}
                    {/*<div className="ant-col gx-col-full ant-col-xs-24 ant-col-sm-24 ant-col-md-12 ant-col-lg-12 ant-col-xl-12">*/}
                    {/*<PropertiesCard/>*/}
                    {/*</div>*/}
                    {/*<div className="ant-col gx-col-full ant-col-xs-24 ant-col-sm-24 ant-col-md-12 ant-col-lg-12 ant-col-xl-12">*/}
                    {/*<PropertiesCard/>*/}
                    {/*</div>*/}
                    {/*<div className="ant-col gx-col-full ant-col-xs-24 ant-col-sm-24 ant-col-md-12 ant-col-lg-12 ant-col-xl-12">*/}
                    {/*<Portfolio/>*/}
                    {/*</div>*/}
                </Row>
            </Auxiliary>
        );
    }
}

const mapStateToProps = ({
    settings,
    commonData,
    auth,
    asset,
    sparePart,
    jobCard,
    complaint,
    assetStockTaking,
    assetTransferAdvice,
    spareTransferAdvice
}) => {
    const { width } = settings;
    return {
        width,
        authUser: auth.authUser,
        assets: asset.allAssets,
        assetGroups: asset.allAssetsGroup,
        assetLoading: asset.allAssetsLoading,
        spares: sparePart.allSpares,
        spareLoading: sparePart.allSparesLoading,
        jobs: jobCard.allJobs,
        openJobs: jobCard.allOpenJobs,
        jobLoading: jobCard.allJobsLoading,
        usAssetCount: complaint.usAssetCount,
        usActiveCount: complaint.usActiveCount,
        usAssetLeaseCount: complaint.usAssetLeaseCount,
        usAssetCountData: complaint.usAssetCountData,
        usAssetCountLoading: complaint.usAssetCountLoading,
        idealAssetCount: asset.idealAssetCount,
        idealAssetCountLoading: asset.idealAssetCountLoading,
        verifiedAssetCount: assetStockTaking.verifiedAssetCount,
        verifiedAssetCountLoading: assetStockTaking.verifiedAssetCountLoading,
        ataCount: assetTransferAdvice.ataCount,
        ataAssetCount: assetTransferAdvice.ataAssetCount,
        ataCountLoading: assetTransferAdvice.ataCountLoading,
        staCount: spareTransferAdvice.staCount,
        staSpareCount: spareTransferAdvice.staSpareCount,
        staCountLoading: spareTransferAdvice.staCountLoading,
        jobDataDownloadLoading: jobCard.dashboardJobDownloadLoading,
        openComplaintCountLoading: complaint.openCountLoading,
        openComplaintCount: complaint.openCount,
        openComplaintCountWithoutJobs: complaint.openWithoutJobCount,

        assetDeviceLastData: asset.assetDeviceLastData,
        taggedDevices: asset.taggedDevices,
        assetTypes: asset.assetTypes,
        equipmentSubTypes: asset.equipmentSubTypes,
        assetModels: asset.assetModels,
        documentFilters: commonData.documentFilters
    };
};

function mapDispatchToProps(dispatch) {
    return {
        getAllAssets,
        getTaggedDeviceAssets,
        getAssetDeviceLastData,
        getAllSpares,
        getAllJobs,
        // getAllOpenJobs,
        getAllOpenJobsByCurrentStatus,
        getUnserviceableAssetCount,
        downloadUnserviceableAsset,
        getIdealAssetCount,
        getVerifiedAssetCount,
        getATACount,
        getSTACount,
        jobCardDownload,
        getOpenCountWithJobs,
        getAllAssetType,
        getEquipmentSubTypeByAssetTypes,
        getModelByAssetMakes,
        fetchFilter,
        fetchAllFiltersData
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(Dashboard);
